export default __webpack_public_path__ + "static/media/item_3@3x.eeb1e8e6.webp";